<template>
  <div>
    <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-12 col-md-8">
            <multiselect v-if="customers" v-model="selected_customer"
                         :allow-empty="false" label="name"
                         :filterable="true" :options="customers"
                         track-by="uuid"
                         placeholder="Select a customer..."
                         @select="customerSelected" />
          </div>
          <div class="col-12 col-md-4">
            <create-customer-modal />
          </div>
        </div>
      </div>
    </div>

    <div v-if="selected_customer && selected_customer.uuid">
      <customer-data :customer="selected_customer" :plans="plans" />
      <user-grid :customer="selected_customer" />
      <customer-organisation-changer :customer-with-organisation="selected_customer" :organisations="organisations" />
    </div>
  </div>
</template>

<script>
import CreateCustomerModal from "VuePartials/Admin/VJSModals/CreateCustomerModal";
import UserGrid from "VuePartials/Admin/UserGrid";
import CustomerData from "VuePartials/Admin/CustomerData";
import CustomerOrganisationChanger from "VuePartials/Admin/CustomerOrganisationChanger";

export default {
  components: {
    CreateCustomerModal,
    UserGrid,
    CustomerData,
    CustomerOrganisationChanger,
  },
  data() {
    return {
      customers: window.customers,
      plans: window.plans,
      selected_customer: null,
      organisations: window.organisations,
    };
  },
  mounted() {
    const vm = this;
    EventBus.$on('customer-updated', (payload) => {
      let target_customer = _.find(vm.customers, customer => customer.uuid === payload.uuid);

      if (target_customer) {
        target_customer = payload;
        vm.selected_customer = target_customer;
      }
    });

    EventBus.$on("customerAdded", (payload) => {
      this.customers.push(payload);
    });
  },
  methods: {
    customerSelected(option) {
      const vm = this;
      // Force components to be re-mounted
      Vue.nextTick(() => {
        vm.selected_customer = null;
        Vue.nextTick(() => {
          vm.selected_customer = option;
        });
      });
    },
  },
};
</script>
